export default "__VITE_ASSET__Dcfd$0S4__"